import React from 'react';
import s from '../../PromoBadge.scss';

export interface Props {
  className?: string;
}

const HexagonLocked24: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      d="M10.588.611a2 2 0 0 1 2.05 0l8.057 4.807a2 2 0 0 1 .975 1.718v9.728a2 2 0 0 1-.975 1.718l-8.057 4.807a2 2 0 0 1-2.05 0l-8.057-4.807a2 2 0 0 1-.975-1.718V7.136a2 2 0 0 1 .975-1.718L10.588.611Z"
      className={s['fill-color']}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.637 2.61a2 2 0 0 0-2.05 0l-6.38 3.806a2 2 0 0 0-.975 1.718v7.728a2 2 0 0 0 .975 1.718l6.38 3.807a2 2 0 0 0 2.05 0L16 19.38V16.61c0-.073.04-.144.11-.195a.45.45 0 0 1 .265-.081h.876v-1.572c0-.732.396-1.434 1.099-1.952a4.207 4.207 0 0 1 1.643-.708V8.134a2 2 0 0 0-.975-1.718l-6.38-3.807Z"
      className={s['fill-color']}
    />
    <path
      d="M21 13c-.596 0-1.168.254-1.59.705a2.493 2.493 0 0 0-.66 1.7v1.663h-.525a.218.218 0 0 0-.16.07.25.25 0 0 0-.065.17v4.452a.255.255 0 0 0 .066.17c.02.022.046.04.073.052a.212.212 0 0 0 .086.018h5.55a.212.212 0 0 0 .16-.07.241.241 0 0 0 .065-.17v-4.452a.255.255 0 0 0-.066-.17.212.212 0 0 0-.16-.07h-.524v-1.664c-.001-.637-.238-1.248-.66-1.699A2.182 2.182 0 0 0 21 13Zm.374 6.57v1.042c0 .106-.04.208-.11.283a.362.362 0 0 1-.264.117.362.362 0 0 1-.265-.117.414.414 0 0 1-.11-.283V19.57a.794.794 0 0 1-.324-.39.861.861 0 0 1-.034-.521.815.815 0 0 1 .27-.435.727.727 0 0 1 .463-.168c.167 0 .33.059.462.168.133.11.228.262.27.435a.861.861 0 0 1-.033.52.794.794 0 0 1-.325.391Zm-1.688-2.502v-1.664c0-.184.033-.367.099-.538.066-.171.163-.326.285-.457.122-.13.267-.235.426-.306a1.241 1.241 0 0 1 1.008 0c.16.071.304.175.426.306.122.13.22.286.285.457.066.17.1.354.099.538v1.664h-2.628Z"
      className={s['fill-color']}
    />
  </svg>
);
HexagonLocked24.displayName = 'HexagonLocked24';

export default HexagonLocked24;
